import { atom } from "jotai";
import { DoctorMSMedicalRecordEntity } from "lib/graphql/megaSchema";

export const chosenMedicalRecordsAtom = atom<DoctorMSMedicalRecordEntity[]>([]);

export const hasDocumentErrorAtom = atom(false);
